import gql from 'graphql-tag';

export interface Program {
  id: string;
  name: string;
  slug: string;
}

export interface ProgramWithSubscribe extends Program {
  isSubscribed: boolean;
}

export interface ProgramWithSubscribeCount extends ProgramWithSubscribe {
  subscriberCount: number;
}

export interface ProgramWithOverlay extends ProgramWithSubscribe {
  description: string;
  totalVideoCount: number;
  totalViewCount: number;
}

export interface ProgramPortrait extends ProgramWithOverlay {
  thumbnail: string;
  hasNewVideo: boolean;
}

export interface ProgramLandscape extends ProgramWithOverlay {
  channel: {
    id: string;
    slug: string;
  };
  largeThumbnail: string;
  hasNewVideo: boolean;
}

export interface ProgramSearchSnippet extends Program {
  thumbnail: string;
}

export const PROGRAM_FRAGMENT = gql`
  fragment Program on GQLProgram {
    id
    name
    slug
  }
`;

export const PROGRAM_SUBSCRIBE_FRAGMENT = gql`
  fragment ProgramWithSubscribe on GQLProgram {
    ...Program
    isSubscribed
  }
  ${PROGRAM_FRAGMENT}
`;

export const PROGRAM_SUBSCRIBE_COUNT_FRAGMENT = gql`
  fragment ProgramWithSubscribeCount on GQLProgram {
    ...ProgramWithSubscribe
    subscriberCount
  }
  ${PROGRAM_SUBSCRIBE_FRAGMENT}
`;

export const PROGRAM_WITH_OVERLAY_FRAGMENT = gql`
  fragment ProgramWithOverlay on GQLProgram {
    ...ProgramWithSubscribe
    description
    totalVideoCount
    totalViewCount
  }
  ${PROGRAM_SUBSCRIBE_FRAGMENT}
`;

export const PROGRAM_PORTRAIT_FRAGMENT = gql`
  fragment ProgramPortrait on GQLProgram {
    ...ProgramWithOverlay
    thumbnail: portraitThumbnail
    hasNewVideo
  }
  ${PROGRAM_WITH_OVERLAY_FRAGMENT}
`;

export const PROGRAM_LANDSCAPE_FRAGMENT = gql`
  fragment ProgramLandscape on GQLProgram {
    ...ProgramWithOverlay
    channel {
      id
      slug
    }
    largeThumbnail: landscapeThumbnail
    hasNewVideo
  }
  ${PROGRAM_WITH_OVERLAY_FRAGMENT}
`;

export interface SubscribeResult {
  subscribe: {
    __typename: string;
    isSubscribed: boolean;
  };
}

export interface UnsubscribeResult {
  unsubscribe: {
    __typename: string;
    isSubscribed: boolean;
  };
}

export interface SubscribeCountResult {
  subscribe: {
    __typename: string;
    isSubscribed: boolean;
    subscriberCount: number;
  };
}

export interface UnsubscribeCountResult {
  unsubscribe: {
    __typename: string;
    isSubscribed: boolean;
    subscriberCount: number;
  };
}
